import React from 'react';
import './App.css';

import AppLoadingScreen from './components/appLoading/AppLoadingScreen';

// ES5

function App() {


  return (
    <div className="App">
      <header className="App-header">
        <AppLoadingScreen />
      </header>
    </div>
  );
}

export default App;
